import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRecentlyViewed, RecentEntry } from '@/lib/recentlyViewed';
import { useI18n } from '@/i18n';

/**
 * Small sidebar section, not a separate nav item — per brief #21
 * ("should improve navigation without cluttering the sidebar"). Re-reads
 * localStorage whenever the route changes, since detail pages are what
 * push new entries.
 */
export function RecentlyViewed() {
  const { t } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();
  const [entries, setEntries] = useState<RecentEntry[]>([]);

  useEffect(() => {
    setEntries(getRecentlyViewed());
  }, [location.pathname]);

  if (entries.length === 0) return null;

  return (
    <div style={{ marginTop: 'auto', paddingTop: 12 }}>
      <div className="group-label">{t('recentlyViewed.title')}</div>
      {entries.slice(0, 5).map((e) => (
        <div key={e.id} className="nav-link" style={{ cursor: 'pointer', fontSize: 12.5 }} onClick={() => navigate(e.route)}>
          {e.label}
        </div>
      ))}
    </div>
  );
}
